<template>

  <div class="advertiser-container">
    <div>通话记录</div>
    <el-row type="flex" justify="end">
      <el-button @click="ExportList()"  icon="el-icon-plus" type="primary">导出</el-button>
    </el-row>
    <el-form inline :model="searchForm" label-width="80px" style="margin-top: 30px;">
     <el-row> 
        <el-form-item label="通话日期">
          <el-date-picker
          v-model="searchForm.dateArray"
          type="daterange"
          range-separator="至"
          value-format="yyyy-M-d"
          start-placeholder="年/月/日"
          end-placeholder="年/月/日">
        </el-date-picker>      
      </el-form-item>
    </el-row>
    <el-row>
        <el-form-item label="关键字" >
            <el-input v-model="searchForm.searchkey" autocomplete="off" style="width:20rem;" placeholder="支持 电话号码/通话编号/工单号/省份/城市"></el-input>
        </el-form-item>
        <el-form-item label="绑定状态">
          <el-select clearable v-model="searchForm.range" placeholder="请选择">
            <el-option v-for="item in rangeList" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-button @click="onSearch" type="primary" icon="el-icon-search">查询</el-button>
      </el-row>
      
    </el-form>

    
    <el-table 
      :data="callLogList.slice((currentPage-1)*PageSize,currentPage*PageSize)" 
      border :header-cell-style="{background:'#eef1f6',color:'#606266'}"  height="750"
			style="width: 80%;margin-top: 10px;" ref="Table" >      
      <el-table-column prop="CallSheetId" align="center" label="通话单号" ></el-table-column>
      <el-table-column prop="sheetCode" align="center" width="150px" label="工单号" >
          <template slot-scope="scope">
            <el-button v-if="scope.row.sheetCode" type="text" @click="onItemEditClick(scope.row)">{{scope.row.sheetCode}}</el-button>   
            <el-button v-else type="text" @click="onItemEditClick(scope.row)">绑定</el-button>           
        </template>
      </el-table-column>
      <el-table-column prop="companyName" align="center" label="客户名称" >
        <template slot-scope="scope">
          <span  v-if="scope.row.companyName" style="color:#3EA7FF;cursor:pointer;" @click="onCompanyEditClick(scope.row)" type="primary">{{scope.row.companyName}}</span>
          <span v-else  style="color:#3EA7FF;cursor:pointer;" @click="onCompanyEditClick(scope.row)">绑定</span>
            <!-- <el-button v-if="scope.row.companyName" type="text" @click="onCompanyEditClick(scope.row)">{{scope.row.companyName}}</el-button>   
            <el-button v-else type="text" @click="onCompanyEditClick(scope.row)">绑定</el-button>            -->
        </template>
      </el-table-column>
      <el-table-column prop="CallNo" align="center" label="主叫号码" ></el-table-column>
      <el-table-column prop="CalledNo" align="center" label="被叫号码" ></el-table-column>
      <el-table-column prop="callType" align="center" label="呼叫类型" ></el-table-column>
      <el-table-column prop="State" align="center" label="通话状态" ></el-table-column>
      <el-table-column prop="Hanguper" align="center" label="挂断方" ></el-table-column>
      <el-table-column prop="HangupCause" align="center" label="通话拦截原因" ></el-table-column>
      <el-table-column prop="callLength" align="center" label="通话时长" ></el-table-column>
      <el-table-column prop="ringLength" align="center" label="振铃时长" ></el-table-column>
      <el-table-column prop="queneLength" align="center" label="排队时长" ></el-table-column>
      
      <el-table-column prop="Ring" align="center" label="响铃1"></el-table-column>
      <el-table-column prop="Begin" align="center" label="接起时间" ></el-table-column>
      <el-table-column prop="End" align="center" label="挂断时间" ></el-table-column>
      <!-- <el-table-column prop="RingingTime" align="center" label="响铃2" ></el-table-column>
      <el-table-column prop="QueueTime" align="center" label="队列时间" ></el-table-column>
      <el-table-column prop="CallTimeLength" align="center" label="时长" ></el-table-column> -->
      
      
      <!-- <el-table-column prop="MonitorFilename" align="center" label="录音文件" >
          <template slot-scope="scope">
            <div v-if="scope.row.MonitorFilename" >
               <el-button
                  v-if="scope.row.showStart" 
                  @click="play(scope.row)" 
                  icon="el-icon-video-play" 
                  type="info" 
                  size="mini" 
                  plain 
                  round
              >播放</el-button>
              <el-button
                  v-else 
                  @click="pause(scope.row)" 
                  icon="el-icon-video-pause" 
                  type="success" 
                  size="mini" 
                  plain 
                  round
              >暂停</el-button>
              <audio :ref="scope.row.CallSheetId" @ended="over(scope.row)">
                  <source :src="scope.row.RecordFile"/>
              </audio>
            </div>            
        </template>
      </el-table-column> -->
      <el-table-column prop="MonitorFilename" align="center" label="录音文件" >
        <template slot-scope="scope">
           <el-link v-if="scope.row.RecordFile" :href="scope.row.MonitorFilename" target="_blank" type="primary">打开</el-link>
        </template>
      </el-table-column>

      

      <el-table-column prop="Province" align="center" label="省份" ></el-table-column>
      <el-table-column prop="District" align="center" label="城市" ></el-table-column>
      <el-table-column prop="Investigate" align="center" label="满意度" ></el-table-column>
      <el-table-column prop="IVRKEY" align="center" label="IVRKEY" ></el-table-column>
      <el-table-column prop="FORM_ID" align="center" label="单号" ></el-table-column>
      <el-table-column prop="CallState" align="center" label="呼叫状态" ></el-table-column>
      <el-table-column prop="IVRKeyName" align="center" label="IVR名称" ></el-table-column>
      <el-table-column prop="Queue" align="center" label="队列" ></el-table-column>
     
<!--         
      <el-table-column  align="center" label="操作" fixed="right">
        <template slot-scope="scope">
            <el-button type="primary" size="small"  @click.native.prevent="onItemEditClick(scope.row)">查看</el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <div class="tabListPage">
           <el-pagination @size-change="handleSizeChange" 
                          @current-change="handleCurrentChange" 
                          :current-page="currentPage" 
                          :page-sizes="pageSizes" 
                          :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper" 
                          :total="totalCount">
             </el-pagination>
       </div>
    <bind-dialog :visible.sync="setCodeVisible" :date-array="searchForm.dateArray"  :searchkey="searchForm.searchkey" :current-item="currentItem"/>
    <bind-company :visible.sync="setCompanyVisible" :date-array="searchForm.dateArray"  :searchkey="searchForm.searchkey" :current-item="currentItem"/>
  </div>
</template>

<script>

import CommonTable from "@/components/CommonTable";
import {getLatestMonthDateArrayByDate,getCurrentDateArray} from "@/utils/time";
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
import {encrypt} from "@/utils/encrypt";
// import {setFinish} from "@/api/workSheet";
import BindDialog from "@/views/CallLog/bindDialog";
import BindCompany from "@/views/CallLog/bindCompany";

export default {
  name: "Advertiser",
  components: { CommonTable,BindDialog,BindCompany}, 
  computed: { ...mapGetters(["callLogList"]) },
  data() {
    return {
      setCodeVisible: false,
      setCompanyVisible:false,
      searchForm: {
        searchkey: "",
        // dateArray: getLatestMonthDateArrayByDate({date:new Date(),delayNum:1, formatValue: 'yyyy-MM-dd'}),
        dateArray: getCurrentDateArray(),
        range:0,
      },
      currentItem: {},
      rangeList:[{label:'全部',value:0},{label:'未绑定工单号',value:1},{label:'未绑定公司',value:2}],
      
      
      // 默认显示第几页
           currentPage:1,
           // 总条数，根据接口获取数据长度(注意：这里不能为空)
           totalCount:0,
           // 个数选择器（可修改）
           pageSizes:[20,50,100],
           // 默认每页显示的条数（可修改）
           PageSize:50,

    };
  },
 

  async created() {
    this.onSearch();
  },

  methods: {    
    async onItemEditClick(item) {
						console.log(item);
						this.currentItem = item;
						this.setCodeVisible = true;
						//编辑成功后发
						// await this.$store.dispatch('base/BaseMediaList',);
		},

    async onCompanyEditClick(item){
      this.currentItem = item;
			this.setCompanyVisible = true;
    },
    
    play(data){
      this.callLogList.map( item =>{
          if(data.CallSheetId === item.CallSheetId){ //获取点击的当前项
              item.showStart = false //将当前按钮显示为暂停
              if(!item.showStart){
                  this.$refs[data.CallSheetId].play(); 
                  console.log('MonitorFilename',data.MonitorFilename)
              }
          }else{ // 非当前项的全部暂停
            if (item.MonitorFilename && this.$refs[item.CallSheetId]){
              // console.log('aa',item.CallSheetId,this.$refs[item.CallSheetId])
              this.$refs[item.CallSheetId].pause();
              item.showStart = true; //将按钮显示为播放
            }
          }
      })
  },
  pause(data){
      data.showStart = true;
      // console.log('data.CallSheetId',data.CallSheetId,this.$refs[data.CallSheetId])
      this.$refs[data.CallSheetId].pause();
  },
  over(data){ //播放结束执行
      data.showStart = true; //播放结束将按钮显示为播放
      // this.callLogList.map((item,index)=>{
      //     if(data.CallSheetId === item.CallSheetId){
      //         if(this.callLogList[index + 1]){ //判断是否当前项播放完毕还有下一项
      //             this.callLogList[index + 1].showStart = false; //将下一项的按钮显示为暂停
      //             this.$refs[this.callLogList[index + 1].CallSheetId].play();//开启下一个
      //         }
      //     }
      // })
  },

  stopAll(){
    this.callLogList.map( item =>{
          
            if (item.MonitorFilename && this.$refs[item.CallSheetId]){
              console.log('aa',item.CallSheetId,this.$refs[item.CallSheetId])
              this.$refs[item.CallSheetId].pause();
              item.showStart = true; //将按钮显示为播放
            }
      })
  },

    // 分页
        // 每页显示的条数
       handleSizeChange(val) {
           // 改变每页显示的条数 
           this.PageSize=val
           // 注意：在改变每页显示的条数时，要将页码显示到第一页
           this.currentPage=1
       },
         // 显示第几页
       handleCurrentChange(val) {
           // 改变默认的页数
           this.currentPage=val
           this.stopAll();
       },

    async ExportList(){
      const [sDate, eDate] = this.searchForm.dateArray;
		  await this.$store.dispatch('bd/CallLogListExport', {
							sDate:sDate,
							eDate:eDate,
              key:this.searchForm.searchkey,
              range:this.searchForm.range,
							});
    },

    async onSearch() {
        const [sDate, eDate] = this.searchForm.dateArray;

      await this.$store.dispatch("bd/callLogList", {
        sDate,
        eDate,
        key:this.searchForm.searchkey,
        range:this.searchForm.range,
      }).then(res=>{
          this.$refs.Table.doLayout();
          this.totalCount=this.callLogList.length
          // console.log('this.callLogList',this.callLogList)
          this.currentPage=1
      });


    },


  },
};
</script>

<style scoped>

</style>